const theme = {
  token: {
    fontFamily: "Inter-Variable",
    colorPrimary: "#0066A6",
    colorInfo: "#E66A25",
    colorPrimaryBg: "#FFFFFF",
    colorBgLayout: "#FCFCFC",
    colorTextBase: "#303030",
    colorBorder: "#D4D4D4",
    colorBorderSecondary: "#fff",
    fontSize: 12,
    borderRadius: 4,
    controlHeight: 30,
    wireframe: false,
    screenXSMax: 639,
    screenSMMin: 640,
    screenSM: 640,
    screenSMMax: 959,
    screenMDMin: 960,
    screenMD: 960,
    screenMDMax: 1279,
    screenLGMin: 1280,
    screenLG: 1280,
    screenLGMax: 1439,
    screenXLMin: 1440,
    screenXL: 1440,
    screenXLMax: 1919,
    screenXXLMin: 1920,
    screenXXL: 1920,
  },
  components: {
    Layout: {
      headerBg: "#fff",
      headerHeight: 56,
      headerPadding: "0 12px",
    },
    Spin: {
      contentHeight: "100vh",
    },
    Input: {
      paddingInlineLG: 16,
      paddingBlock: 2,
      paddingBlockLG: 11,
    },
    InputNumber: {
      paddingBlock: 5,
    },
    DatePicker: {
      paddingBlock: 5, // not working -_-
    },
    Button: {
      paddingInlineLG: 16,
      paddingBlockLG: 11,
    },
    Select: {
      multipleItemHeight: 24,
    },
    Menu: {
      itemBg: "#FCFCFC",
      itemSelectedBg: "#fff",
      itemHoverBg: "#fff",
      itemColor: "#777777",
      itemSelectedColor: "#303030",
      itemHoverColor: "#303030",
      subMenuItemBg: "#F7F7F7",
      subMenuItemBorderRadius: 0,
      subMenuItemSelectedColor: "#303030",
      activeBarBorderWidth: 0,
      collapsedWidth: 60,
      itemPaddingInline: 10,
      iconSize: 20,
      itemMarginBlock: 0,
      itemMarginInline: 0,
    },
    Descriptions: {
      titleMarginBottom: 0,
      itemPaddingBottom: 5,
    },
    Collapse: {
      headerBg: "#FCFCFC",
    },
    Table: {
      headerBg: "#f8fbff",
      headerColor: "#777777",
      headerSortActiveBg: "#f8fbff",
      headerSortHoverBg: "#fcfcfc",
      headerSplitColor: "transparent",
      bodySortBg: "#fff",
      borderColor: "#f7f7f7",
      cellPaddingBlock: 12,
      cellPaddingInline: 12,
      rowHoverBg: "#fcfcfc",
      rowSelectedHoverBg: "#fcfcfc",
      footerBg: "#fff",
    },
    Pagination: {
      itemActiveBg: "#F7F7F7",
      itemBg: "transparent",
    },
    Breadcrumb: {
      itemColor: "#777777",
      lastItemColor: "#777777",
      separatorColor: "#777777",
      linkColor: "#777777",
      linkHoverColor: "#e66a25",
      separatorMargin: 4,
    },
    Checkbox: {
      controlInteractiveSize: 16,
    },
    Segmented: {
      itemColor: "#777777",
      trackBg: "#E9E9E9",
      trackPadding: 4,
      itemSelectedBg: "#FFFFFF",
    },
    Card: {
      bodyPadding: "16px 20px",
      headerPadding: 20,
    },
    Tabs: {
      inkBarColor: "#303030",
      itemSelectedColor: "#303030",
      itemColor: "#777777",
      itemHoverColor: "#303030",
      itemActiveColor: "#303030",
      titleFontSize: 14,
    },
    Modal: {
      titleFontSize: 20,
      contentBg: "#FCFCFC",
      footerBg: "#FCFCFC",
      headerBg: "#FCFCFC",
    },
  },
};

export default theme;

// https://ant.design/theme-editor#Style
// Вот тут можно посмотреть как будет выглядеть тема и настроить ее
